import {
  DEFAULT_MAX_VIDEO_BYTES,
  MODELS,
  clearRuntimeModels,
  getAllModels,
  getAuthStorageKey,
  getAuthStorageKeys,
  getContextWindow,
  getDefaultModel,
  getDefaultThinkingLevel,
  getFastModel,
  getMaxThinkingLevel,
  getModel,
  getModelsForProvider,
  getSummaryModel,
  getToolResultCharLimit,
  getVideoByteLimit,
  registerRuntimeModels,
  usesOpenAICodexTransport
} from "./chunk-VMWOH3GU.js";
import "./chunk-EAIPT76S.js";
export {
  DEFAULT_MAX_VIDEO_BYTES,
  MODELS,
  clearRuntimeModels,
  getAllModels,
  getAuthStorageKey,
  getAuthStorageKeys,
  getContextWindow,
  getDefaultModel,
  getDefaultThinkingLevel,
  getFastModel,
  getMaxThinkingLevel,
  getModel,
  getModelsForProvider,
  getSummaryModel,
  getToolResultCharLimit,
  getVideoByteLimit,
  registerRuntimeModels,
  usesOpenAICodexTransport
};
//# sourceMappingURL=model-registry.js.map